import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Input,
  Tooltip
} from '@material-ui/core';
import React, { useState } from 'react';
import * as S from './styles';
import InfoIcon from '@material-ui/icons/Info';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import { useMessageBox } from '../../../context/MessageBox';
import api from '../../../services/api';
import { ConfirmationBox } from '../../../components/ConfirmationBox';
import { AnchorSelectBox } from '../../../components/AnchorSelectBox'
import { toast } from 'react-toastify';
import { consultarPorAncoraId } from '../../../services/ancorasImportacoesTitulosService';
import ModalConfirmarImportacaoBluesoft from '../components/ModalConfirmarImportacaoBluesoft';

function AnchorsLogoOptions({
  anchors,
  handleSelectAnchor,
  selectedAnchor,
  reloadRightTable,
  loadingProposals,
  loadingMetas,
  loadingRight,
  setIsLoading,
}) {
  const { setMessageData } = useMessageBox();
  const [newSelectedAnchor, setNewSelectedAnchor] = useState({});
  const [infoRede, setInfoRede] = useState('');
  const [infoOpen, setInfoOpen] = useState(false);
  const [confirmationBox, setConfirmationBox] = useState({
    show: false,
    type: '',
    htmlText: '',
    callback: () => { },
    closeBtnLastLayout: false,
    labelClose: '',
    anchorTitle: '',
    onlyOneButton: false
  });

  const [anchorsModal, setAnchorsModal] = useState({
    show: false,
    callback: () => { },
    anchors: [],
    newSelectedAnchor: {},
    closeModal: () => { }
  })

  const [bluesoftModal, setBluesoftModal] = useState({
    open: false,
    tipo: 'full',
    vinculos: [],
  });
  const [carregandoVinculos, setCarregandoVinculos] = useState(false);

  const isImportacaoApi = (selectedAnchor?.importacaoVia || 'Arquivo') === 'Api';

  const abrirModalBluesoft = async (tipo) => {
    if (!selectedAnchor?.ancoraId || carregandoVinculos) return;
    try {
      setCarregandoVinculos(true);
      let ancora = selectedAnchor;
      // Fallback: se por algum motivo importacaoVia nao vier na listagem, consulta detalhado.
      if (!ancora?.importacaoVia) {
        try {
          const resp = await api.get(
            `Ancoras/ConsultarId?id=${selectedAnchor.ancoraId}`,
          );
          const d = Array.isArray(resp?.data?.resposta)
            ? resp.data.resposta[0]
            : resp?.data?.resposta;
          if (d) ancora = { ...ancora, ...d };
        } catch (e) {
          // segue mesmo assim; a verificacao abaixo trata como Arquivo
        }
      }
      const via = ancora?.importacaoVia || 'Arquivo';
      if (via !== 'Api') {
        // Nao deveria chegar aqui, mas por seguranca cai no fluxo antigo.
        const inputId = tipo === 'complementar' ? 'uploudComplementaryFile' : 'uploudMainFile';
        document.getElementById(inputId)?.click();
        return;
      }
      const lista = await consultarPorAncoraId(selectedAnchor.ancoraId);
      const ativos = (lista || []).filter((v) => v.status === 'Ativo');
      setBluesoftModal({ open: true, tipo, vinculos: ativos });
    } catch (error) {
      handleErrorRequest(error?.response);
      toast.error('Falha ao consultar integracoes Bluesoft.');
    } finally {
      setCarregandoVinculos(false);
    }
  };

  const fecharModalBluesoft = () => {
    setBluesoftModal({ open: false, tipo: 'full', vinculos: [] });
  };


  const fetchInfo = async () => {
    try {
      const response = await api.get(`OperacoesAntecipacoes/ConsultarInformacoesRede?ancoraId=${selectedAnchor?.ancoraId}`);
      if (response.data.status !== 'Inconsistencia') {

        setInfoRede(response.data.resposta)
        setInfoOpen(true);
        setConfirmationBox({
          show: true,
          type: 'anchorInfo',
          htmlText: response.data.resposta,
          callback: () => { },
          closeBtnLastLayout: false,
          labelClose: 'Fechar',
          anchorTitle: selectedAnchor?.apelido,
          onlyOneButton: true
        })
      } else {
        handleErrorRequest(response);
        setMessageData(response?.data?.complemento?.mensagensBox);
      }
    } catch (error) {
      setMessageData(error?.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
  }

  const handleSelecteAnchor = (anchor) => {
    setNewSelectedAnchor(anchor);
    handleSelectAnchor(anchor);
    closeModal()
  }

  const closeModal = () => {
    setAnchorsModal({
      show: false,
      callback: () => { },
      anchors: [],
      newSelectedAnchor: {},
      closeModal: () => { }
    })
  }

  const uploadArquivosNotas = async (complementar, file) => {
    try {
      const formData = new FormData();
      formData.append('arquivo', file);
      const response = await api.post(`OperacoesAntecipacoes/UploadArquivosDeNotas?ancoraId=${selectedAnchor.ancoraId}&arquivoComplementar=${complementar}`, formData);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        toast.success(response.data.resposta.mensagem.replace('<br>', '\n'));
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      setMessageData(error.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    } finally {
      document.getElementById("uploudMainFile").value = "";
      document.getElementById("uploudComplementaryFile").value = "";
      setNewSelectedAnchor(selectedAnchor);
      handleSelectAnchor(selectedAnchor);
    }
  }

  const handleFileChange = async (event, complementar) => {
    const file = event.target.files[0];
    if (file) {
      await uploadArquivosNotas(complementar, file)
    }
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const copyToClipboard = (complementar) => {

    const text = complementar ?
      selectedAnchor.caminhoFisicoArmazenamentoLocalArquivosNotasComplementar :
      selectedAnchor.caminhoFisicoArmazenamentoLocalArquivosNotasPrincipal;

    if (navigator.clipboard) {

      navigator.clipboard.writeText(text).then(() => {
        console.log("Texto copiado", text);
      }).catch(err => {
        console.error('Erro ao copiar o texto: ', err);
      });
    }
    else {

      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        console.log("Texto copiado", text);
      } catch (err) {
        console.error('Erro ao copiar o texto: ', err);
      }
      document.body.removeChild(textarea);
    }

  };

  return (
    <>
      <S.MetasBox>
        <S.TableTitleHeader>
          <Tooltip placement="top" title={isImportacaoApi ? 'Disparar Carga Full (Bluesoft)' : 'Arquivo Principal'}>
            {isImportacaoApi ? (
              <Button
                style={{ minWidth: 'auto', padding: 0 }}
                onClick={() => abrirModalBluesoft('full')}
                disabled={carregandoVinculos}
              >
                <FileDownloadIcon style={{ color: '#689f38' }} className="pointer" />
              </Button>
            ) : (
              <Button component="label" style={{ minWidth: 'auto', padding: 0 }}
                onClick={() => copyToClipboard(false)}
              >
                <FileDownloadIcon style={{ color: '#689f38' }} className="pointer" />
                <input
                  name="uploadArquivosNotasPrincipal"
                  type="file"
                  id="uploudMainFile"
                  hidden={true}
                  onChange={(event) => {
                    handleFileChange(event, false);
                  }}
                  autoComplete="off"
                />
              </Button>
            )}
          </Tooltip>
          <Tooltip placement="top" title={isImportacaoApi ? 'Disparar Carga Complementar (Bluesoft)' : 'Arquivo Complementar'}>
            {isImportacaoApi ? (
              <Button
                style={{ minWidth: 'auto', padding: 0 }}
                onClick={() => abrirModalBluesoft('complementar')}
                disabled={carregandoVinculos}
              >
                <FileDownloadIcon style={{ color: '#f0a918' }} className="pointer" />
              </Button>
            ) : (
              <Button component="label" style={{ minWidth: 'auto', padding: 0 }}
                onClick={() => copyToClipboard(true)}
              >
                <FileDownloadIcon style={{ color: '#f0a918' }} className="pointer" />
                <input
                  name="uploadArquivosNotasPrincipal"
                  type="file"
                  hidden={true}
                  id="uploudComplementaryFile"
                  onChange={(event) => {
                    handleFileChange(event, true);
                  }}
                  autoComplete="off"
                />
              </Button>
            )}
          </Tooltip>
          <h3 className="operation-title text-center">Plataformas/Redes</h3>
          <Tooltip placement="top" title="Informações">
            <InfoIcon className="pointer" onClick={() => fetchInfo()} />
          </Tooltip>
        </S.TableTitleHeader>
        <S.MetasContainer>
          <S.AnchorLogo onClick={() => {
            if (
              !loadingRight &&
              !loadingProposals &&
              !loadingMetas
            ) {
              setAnchorsModal({
                show: true,
                callback: handleSelecteAnchor,
                anchors: anchors,
                newSelectedAnchor: selectedAnchor,
                closeModal: closeModal
              })
            }
          }}>
            {selectedAnchor?.logotipoLink ? (
              <img
                style={{ objectFit: 'contain', background: 'white' }}
                src={selectedAnchor?.logotipoLink}
                alt={`Logo da rede ${selectedAnchor?.nomeFantasia ? selectedAnchor?.nomeFantasia : selectedAnchor?.plataforma}`}
              />
            ) : (
              <div style={{ cursor: 'pointer' }}>
                {selectedAnchor?.nomeFantasia ? selectedAnchor?.nomeFantasia : selectedAnchor?.plataforma}
              </div>
            )}
          </S.AnchorLogo>
        </S.MetasContainer>
      </S.MetasBox>

      {confirmationBox.show && (
        <ConfirmationBox
          data={confirmationBox}
          setConfirmationBox={setConfirmationBox}
        ></ConfirmationBox>
      )}

      {/* <S.DialogModal open={infoOpen} onClose={() => setInfoOpen(false)} fullWidth={true} >
        <S.DialogTitleBg>Informação da rede <br></br>{selectedAnchor?.nomeFantasia}</S.DialogTitleBg>

        <S.DialogHtmlDiv dangerouslySetInnerHTML={{ __html: infoRede }} id="infoModal">
        </S.DialogHtmlDiv>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </S.DialogModal> */}

      {anchorsModal.show && (
        <AnchorSelectBox
          data={anchorsModal}
        ></AnchorSelectBox>
      )}

      {bluesoftModal.open && (
        <ModalConfirmarImportacaoBluesoft
          open={bluesoftModal.open}
          tipo={bluesoftModal.tipo}
          vinculos={bluesoftModal.vinculos}
          onClose={fecharModalBluesoft}
          onSuccess={() => {
            // Recarrega a ancora selecionada para refletir eventuais mudancas
            if (selectedAnchor) {
              setNewSelectedAnchor(selectedAnchor);
              handleSelectAnchor(selectedAnchor);
            }
          }}
        />
      )}
    </>
  );
}

export default AnchorsLogoOptions;
